import { boot } from 'quasar/wrappers';
import axios from 'axios';
import type { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import type { IAPIErrorRes } from '@/types/IAPIRes';
import { LocalStorage } from 'quasar';

const APP_BASE_URL =   import.meta.env.VITE_APP_BASE_URL||'https://back.uxexam.com';
  // import.meta.env.VITE_APP_BASE_URL || 'http://127.0.0.1:8000';
  // process.env.VITE_APP_BASE_URL || 'https://r.akwad.sa';

const APP_BASE_URL_LAB =
  import.meta.env.VITE_APP_LAB_URL || 'https://lab.uxexam.com';

const axiosInstance: AxiosInstance = axios.create({
  baseURL: `${APP_BASE_URL}/api/v1`,
});

const axiosInstanceLab: AxiosInstance = axios.create({
  baseURL: `${APP_BASE_URL_LAB}/api`,
});

const axiosAuth: AxiosInstance = axios.create({
  baseURL: `${APP_BASE_URL}/api/v1`,
});

// Configure axiosInstance interceptors
axiosInstance.interceptors.request.use(
  (config) => {
    if (LocalStorage.getItem('auth')) {
      const token = JSON.parse(LocalStorage.getItem('auth')!).token || false;
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError<IAPIErrorRes>) => Promise.reject(error),
);

// Configure axiosAuth interceptors
axiosAuth.interceptors.request.use(
  (config) => {
    let token;
    if (LocalStorage.getItem('auth'))
      token = JSON.parse(LocalStorage.getItem('auth')!).token;
    else throw new Error('NO_TOKEN');

    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);

axiosAuth.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => Promise.reject(error),
);

export default boot(({ app }) => {
  app.config.globalProperties.$axios = axiosInstance;
  app.config.globalProperties.$axiosAuth = axiosAuth;
  app.provide('axios', axiosInstance);
});

function useAxios() {
  return {
    axiosInstance,
    axiosAuth,
    axiosInstanceLab
  };
}

export { useAxios, APP_BASE_URL };
